export const yesNoFilter = (value: boolean): string => {
    if (value !== null && value !== undefined) {
        return value ? "Yes" : "No";
    } else {
        return "No";
    }
};
